<div id="content" class="flexColumnContainer">
  <div class="flexColumnContainer justifyContentSpaceBetween">
    <div id="titleAndButtonContainer" class="flexRowContainer justifyContentSpaceBetween">
      <div class="breadcrumbContainer">
        <span class="breadcrumb currentSite">{{ 'caseOverview.title' | translate }}</span>
      </div>
    </div>
    <div id="searchAndToggleContainer" class="flexRowContainer justifyContentSpaceBetween">
      <mat-form-field id="caseSearch" class="m3-search-field" appearance="fill">
        <input
          #caseSearchInput
          matInput
          type="text"
          [placeholder]="'caseOverview.search.label' | translate"
          aria-label="Search"
          [formControl]="searchCasesControl">
        <mat-icon matPrefix class="material-icons-outlined">search</mat-icon>

        @if (searchCasesControl.value?.length) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            aria-label="Clear search"
            (click)="clearSearch(caseSearchInput)">
            <mat-icon class="material-icons-outlined">close</mat-icon>
          </button>
        }
      </mat-form-field>
      <mat-slide-toggle [checked]="onlyShowMyCases" (change)="toggleOnlyShowMyCases()">
        {{ 'caseOverview.toggles.onlyMyProcesses.label' | translate }}
      </mat-slide-toggle>
    </div>
  </div>
  <div id="caseActionsContainer" class="flexRowContainer justifyContentSpaceBetween">
    <app-selection-actions-bar
      id="selectedCasesActions"
      selectionLabelKey="caseOverview.selection.chosen"
      [selectedCount]="selectedCases.length"
      [reserveSpaceWhenEmpty]="true"
    >
      <app-selection-action
        icon="download"
        [tooltip]="canAllSelectedCasesBeDownloaded(getSelectedCases()) ? ('caseOverview.tooltips.downloadSelectedCases' | translate) : ('caseOverview.tooltips.downloadSelectedCasesDisabled' | translate)"
        [disabled]="!canAllSelectedCasesBeDownloaded(getSelectedCases())"
        (actionTriggered)="downloadSelectedCasesDocuments()">
      </app-selection-action>
      <app-selection-action
        icon="assignment_ind"
        [tooltip]="canAllSelectedCasesBeAssigned() ? ('caseOverview.buttons.assignSelected.label' | translate) : ('caseOverview.tooltips.assignSelectedCasesDisabled' | translate)"
        [disabled]="!canAllSelectedCasesBeAssigned()"
        (actionTriggered)="assignSelectedCases()">
      </app-selection-action>
      <app-selection-action
        icon="delete"
        [tooltip]="canAllSelectedCasesBeDeleted() ? ('caseOverview.tooltips.deleteSelectedCases' | translate) : ('caseOverview.tooltips.deleteSelectedCasesDisabled' | translate)"
        [disabled]="!canAllSelectedCasesBeDeleted()"
        (actionTriggered)="deleteSelectedCases()">
      </app-selection-action>
    </app-selection-actions-bar>
    @if (createCaseLink) {
      <button mat-flat-button id="createNewCaseButton" (click)="createCase()">
        <mat-icon class="material-symbols-outlined">folder_add</mat-icon>
        <span id="headerButtonText">{{ 'caseOverview.buttons.createNewCase.label' | translate }}</span>
      </button>
    }
  </div>
  <section id="tableContainer" class="selectable-table-container has-leading-indicator" [ngClass]="{'loading': loadingCases}">
    @if (loadingCases) {
      <div id="matSpinnerContainer">
        <mat-spinner id="loadingSpinner" [diameter]="50"></mat-spinner>
      </div>
    }
    <table class="selectable-table" mat-table [dataSource]="dataSource" matSort [matSortActive]="sortActive" [matSortDirection]="sortDirection">
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <ng-container matColumnDef="selection">
        <th mat-header-cell *matHeaderCellDef>
          <app-table-selection-cell
            [checked]="areAllCasesSelected()"
            [indeterminate]="areSomeCasesSelected()"
            [disabled]="getSelectableCaseCount() === 0"
            [ariaLabel]="'caseOverview.selection.selectAll' | translate:{selectedCount: selectedCases.length, totalCount: getSelectableCaseCount()}"
            (toggled)="selectionChangeAll()"
          ></app-table-selection-cell>
        </th>
        <td mat-cell *matCellDef="let casee">
          @if (isUnassignedCase(casee)) {
            <span
              class="case-unassigned-dot"
              [matTooltip]="'caseOverview.badges.unassignedCase' | translate"></span>
          }
          <app-table-selection-cell
            [row]="true"
            [checked]="selectedCases.includes(casee.identification)"
            [disabled]="!isCaseSelectable(casee)"
            [ariaLabel]="('caseOverview.table.name' | translate) + ': ' + casee.name"
            (toggled)="selectionChanged(casee.identification)"
          ></app-table-selection-cell>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'caseOverview.table.name' | translate }}</th>
        <td mat-cell *matCellDef="let casee" class="clickableTableCell case-name-cell" (click)="navigateToCaseDetail(casee)"
            (keydown.enter)="navigateToCaseDetail(casee)">
          <div class="table-primary-cell-content">
            <div class="flexColumnContainer caseInfoContainer">
              <span class="body-medium">{{ casee.name }}</span>
              <span class="body-small">{{ casee.reference }}</span>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="client">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="clientName">{{ 'caseOverview.table.client' | translate }}</th>
        <td mat-cell *matCellDef="let casee" class="clickableTableCell" (click)="navigateToCaseDetail(casee)"
            (keydown.enter)="navigateToCaseDetail(casee)">
          <div class="flexColumnContainer">
            <span class="body-medium">
              {{ casee.clientName }}
            </span>
            @if (casee.clientAdditionalInfo) {
              <app-additional-user-info class="body-small"
                                        [text]="casee.clientAdditionalInfo"></app-additional-user-info>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="assignee">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="assigneeName">{{ 'caseOverview.table.assignee.title' | translate }}</th>
        <td mat-cell *matCellDef="let casee">
          @if (casee.assigneeName) {
            <div>
              <span class="body-medium">
                {{ casee.assigneeName }}
              </span>
            </div>
          }
          @if (shouldShowUnassignedAssignee(casee) && casee._links?.hasLink('update')) {
            <div id="notAssignedContainer" class="flexRowContainer">
              <span class="body-medium">
                {{ 'caseOverview.table.assignee.pending' | translate }}
              </span>
              <button mat-icon-button (click)="openAssignCaseModal(casee)">
                <mat-icon class="material-symbols-outlined">assignment_ind</mat-icon>
              </button>
            </div>
          }
          @if (shouldShowUnassignedAssignee(casee) && !casee._links?.hasLink('update')) {
            <span class="body-medium">
              {{ 'caseOverview.table.assignee.pending' | translate }}
            </span>
          }
          @if (!casee.assigneeName && !shouldShowUnassignedAssignee(casee)) {
            <span class="body-medium">-</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="createdDate">
        <th id="actionHeader" mat-header-cell *matHeaderCellDef
            mat-sort-header>{{ 'caseOverview.table.createdOn' | translate }}
        </th>
        <td mat-cell *matCellDef="let casee" class="clickableTableCell" (click)="navigateToCaseDetail(casee)"
            (keydown.enter)="navigateToCaseDetail(casee)">
          <span class="body-medium">
            {{ casee.creationDate | date:'dd.MM.yyyy, HH:mm' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="lastModifiedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="lastModifiedDate">
          {{ 'caseOverview.table.lastChange' | translate }}
        </th>
        <td mat-cell *matCellDef="let casee" class="clickableTableCell" (click)="navigateToCaseDetail(casee)"
            (keydown.enter)="navigateToCaseDetail(casee)">
          <span class="body-medium">
            {{ casee.lastModifiedDate ? (casee.lastModifiedDate | date:'dd.MM.yyyy, HH:mm') : '-' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef>
          <div class="stateHeader">
            <span>{{ 'caseOverview.table.state' | translate }}</span>
            <app-case-state-filter
              [states]="stateFilterOptions"
              [selectedStates]="selectedStateFilters"
              (selectedStatesChange)="updateStateFilters($event)">
            </app-case-state-filter>
          </div>
        </th>
        <td mat-cell *matCellDef="let casee" class="clickableTableCell" (click)="navigateToCaseDetail(casee)"
            (keydown.enter)="navigateToCaseDetail(casee)">
          <div class="flexColumnContainer">
            <span id="stateTag" class="documentTagRemake"
                  [ngClass]="casee.state.toLowerCase()">{{ 'caseOverview.table.states.' + casee.state.toLowerCase() | translate }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let casee">
          <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="isCaseAutomated(casee)">
            <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
          </button>
          <mat-menu class="matActionsMenu" #menu="matMenu">
            <button mat-menu-item (click)="openAssignCaseModal(casee)"
                    [disabled]="!casee._links?.hasLink('update')">
              <mat-icon class="material-symbols-outlined">assignment_ind</mat-icon>
              <span class="body-large">{{ 'caseOverview.table.menu.buttons.assign' | translate }}</span>
            </button>
            <button mat-menu-item (click)="navigateToCaseDetail(casee)">
              <mat-icon class="material-symbols-outlined">edit</mat-icon>
              <span class="body-large">{{ 'caseOverview.table.menu.buttons.edit' | translate }}</span>
            </button>
            @if (casee._links?.hasLink('move')) {
              <button id="moveCaseMenuItem" mat-menu-item (click)="openMoveCaseModal(casee)">
                <mat-icon class="material-symbols-outlined">move_item</mat-icon>
                <span class="body-large">{{ 'caseOverview.table.menu.buttons.move' | translate }}</span>
              </button>
            }
            <button mat-menu-item (click)="openDeleteCaseConfirmationModal(casee)"
                    [disabled]="!casee._links?.hasLink('delete')">
              <mat-icon class="material-symbols-outlined">delete</mat-icon>
              <span class="body-large">{{ 'caseOverview.table.menu.buttons.delete' | translate }}</span>
            </button>
            <button disabled mat-menu-item>
              <mat-icon class="material-symbols-outlined">archive</mat-icon>
              <span class="body-large">{{ 'caseOverview.table.menu.buttons.archive' | translate }}</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr id="tableRow" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </section>
  @if (!loadingCases && dataSource.data.length === 0) {
    <div id="noCasesContainer" class="flexColumnContainer">
      <p id="noTeamTitle" class="headline-medium">{{ 'caseOverview.noCases.title' | translate }}</p>
      <img id="noCasesLogo" [src]="'logo_small.png' | tenantSpecificAsset" alt="Logo"/>
    </div>
  }
  <mat-paginator
    [pageSize]="pagedCaseOverviewHal.page.size"
    [pageIndex]="pagedCaseOverviewHal.page.number"
    [length]="pagedCaseOverviewHal.page.totalElements"
    [pageSizeOptions]="[5, 10, 20, 40]"
    (page)="updateCasesHal($event)"></mat-paginator>
</div>
